/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Min_BagsInputs */

const en_cargos_min_bags = /** @type {(inputs: Cargos_Min_BagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min bags`)
};

const es_cargos_min_bags = /** @type {(inputs: Cargos_Min_BagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bolsas min`)
};

/**
* | output |
* | --- |
* | "Min bags" |
*
* @param {Cargos_Min_BagsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_min_bags = /** @type {((inputs?: Cargos_Min_BagsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Min_BagsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_min_bags(inputs)
	return es_cargos_min_bags(inputs)
});